module.exports = "<div class=\"col my-2 mt-4 card-wrapper \">\n    <div class=\"p-2 card mt-4\">\n        <h3 class=\"mb-4 ml-4 mt-4\"></h3>\n        <div class=\"alert alert-danger mx-4\">This feature is not enabled for this school. </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/parent-home/parent-home.component.html
// module id = ../../../../../src/app/parent/dashboard/pages/parent-home/parent-home.component.html
// module chunks = main